import { forwardRef, Fragment } from "react";
import { Link } from "react-router-dom";
import { useDemo1Layout } from "../";
import { toAbsoluteUrl } from "@/utils";
import { SidebarToggle } from "./";
import horizontalUniLogo from '@/assets/images/horizonal-uni-logo.svg'
const SidebarHeader = forwardRef((props, ref) => {
  const {
    layout
  } = useDemo1Layout();
  const lightLogo = () => <Fragment>
      <Link to="/" className="dark:hidden rounded-lg transition-colors duration-200 p-1">
        <img src={toAbsoluteUrl('/media/images/logo_ngang.png')} className="default-logo h-8 max-w-none" />
        <img src={toAbsoluteUrl('/media/images/logo_mini_chatme.png')} className="small-logo h-8 max-w-none" />
      </Link>
      <Link to="/" className="hidden dark:block rounded-lg transition-colors duration-200 group-hover:bg-[#23272B] p-1">
        <img src={toAbsoluteUrl('/media/app/default-logo-dark.svg')} className="default-logo min-h-[22px] max-w-none" />
        <img src={toAbsoluteUrl('/media/app/mini-logo.svg')} className="small-logo min-h-[22px] max-w-none" />
      </Link>
    </Fragment>;
  const darkLogo = () => <Link to="/" className="rounded-lg transition-colors duration-200 group-hover:bg-[#23272B] p-1">
      <img src={toAbsoluteUrl('/media/app/default-logo-dark.svg')} className="default-logo min-h-[22px] max-w-none" />
      <img src={toAbsoluteUrl('/media/app/mini-logo.svg')} className="small-logo min-h-[22px] max-w-none" />
    </Link>;
  return <div ref={ref} className="sidebar-header hidden lg:flex items-center relative justify-between px-2 shrink-0 bg-[#50B553] transition-colors duration-200 group-hover:bg-white dark:group-hover:bg-[#23272B]">
      {layout.options.sidebar.theme === 'light' ? lightLogo() : darkLogo()}
      {/* <SidebarToggle /> */}
    </div>;
});
export { SidebarHeader };
